<div>
  <router-outlet></router-outlet>
  <!-- <app-responsive-helper></app-responsive-helper> -->
  <app-loading></app-loading>
</div>